import styled from "styled-components";

export const TaskGridWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
  gap: var(--spacingL);
  width: 100%;
  margin: 0px;
  padding: 0px;

  @media screen and (min-width: 1128px) {
    flex-direction: row;
    gap: var(--spacingS);
  }
`;
